<template>
  <MasterdataTableContainer
    :loading="false"
    :headers="headers"
    :table-data="tableData"
    :sort-by="sortBy"
    :sort-desc="true"
    :refetch="refetch"
    @row-click="onRowClick"
    :actions="actions"
  />
</template>

<script>
import gql from 'graphql-tag'
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import { format } from 'date-fns'
import paramsDistrict from '@/common/paramsDistrict.js'
import HistoryEventReEnableModal from './HistoryEventReEnableModal'

export default {
  name: 'HistoryTable',

  components: {
    MasterdataTableContainer
  },

  data() {
    return {
      sortBy: 'created',
      actions: [
        {
          title: 'Återaktivera',
          icon: 'mdi-pencil',
          component: HistoryEventReEnableModal,
          type: 're-enable'
        }
      ],
      headers: [
        {
          text: 'Händelserubrik',
          value: 'title'
        },
        {
          text: 'Händelsetid',
          value: '_time_start'
        },
        {
          text: 'Sträckor',
          value: '_routes'
        },

        {
          text: 'Plats',
          value: 'location'
        },
        {
          text: 'Orsak',
          value: 'reason.name'
        },
        {
          text: 'Driftnivå',
          value: 'operation_level.name'
        },
        {
          text: 'Basunnr.',
          value: 'basun'
        },
        {
          text: 'Basuntid',
          value: '_basun_time'
        },
        {
          text: 'Prognos',
          value: 'forecast.name'
        },
        {
          text: 'Kommentar',
          value: 'comment'
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'right'
        }
      ]
    }
  },

  apollo: {
    events: {
      query: gql`
        query events($filter: GetEventsInput!) {
          events(filter: $filter) {
            uuid
            created
            created_by
            updated
            updated_by
            title
            comment
            time_start
            location
            basun
            basun_time
            operation_level {
              name
            }
            reason {
              name
            }
            routes {
              from_place
              to_place
            }
          }
        }
      `,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            archived: true,
            district_id: this.$store.get('app/selectedDistrictId')
          }
        }
      }
    }
  },

  computed: {
    tableData() {
      return (this.events || []).map(x => ({
        ...x,
        _routes: (x.routes || [])
          .map(x => `${x.from_place} - ${x.to_place}`)
          .join(', '),
        _time_start: format(new Date(x.time_start), 'yyyy-MM-dd HH:mm'),
        _basun_time: x.basun
          ? format(new Date(x.basun_time), 'yyyy-MM-dd HH:mm')
          : null
      }))
    }
  },

  methods: {
    refetch() {
      this.$apollo.queries.events.refetch()
    },

    onRowClick({ uuid }) {
      this.$router.push(
        `/${paramsDistrict(
          this.$store.get('app/selectedDistrictId')
        )}/history/${uuid}`
      )
    }
  }
}
</script>
